"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Callback = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hooks = require("../../hooks");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var AUTHENTICATION_IN_PROGRESS = 'AUTHENTICATION_IN_PROGRESS';
var AUTHENTICATION_SUCCEEDED = 'AUTHENTICATION_SUCCEEDED';
var AUTHENTICATION_FAILED = 'AUTHENTICATION_FAILED';
;

var Callback = function Callback(props) {
  var onSuccess = props.onSuccess,
      onFailure = props.onFailure;

  var _useState = (0, _react.useState)(AUTHENTICATION_IN_PROGRESS),
      _useState2 = _slicedToArray(_useState, 2),
      status = _useState2[0],
      setStatus = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      errorDescription = _useState4[0],
      setErrorDescription = _useState4[1];

  var authManager = (0, _hooks.useAuthManager)();
  (0, _react.useEffect)(function () {
    if (authManager !== null) {
      // on mount use the authManager to parse the callback URL params via handleAuthentication
      authManager.handleAuthentication().then(function (user) {
        setStatus(AUTHENTICATION_SUCCEEDED); // if onSuccess was passed, called it with the user object

        if (onSuccess) {
          onSuccess(user);
        }
      }).catch(function (err) {
        setStatus(AUTHENTICATION_FAILED);
        setErrorDescription(_lodash.default.get(err, ['message'], 'An error occurred.')); // if onFailure was passed, call it with the error

        if (onFailure) {
          onFailure(err);
        }
      });
    }
  }, []); // render output

  switch (status) {
    case AUTHENTICATION_IN_PROGRESS:
      return _react.default.createElement("div", null, "Logging you in...");

    case AUTHENTICATION_SUCCEEDED:
      return _react.default.createElement("div", null, "You have been logged in.");

    case AUTHENTICATION_FAILED:
    default:
      return _react.default.createElement("div", null, errorDescription);
  }
};

exports.Callback = Callback;
Callback.propTypes = {
  onSuccess: _propTypes.default.func,
  onFailure: _propTypes.default.func
};
Callback.defaultProps = {
  onSuccess: null,
  onFailure: null
};
var _default = Callback;
exports.default = _default;